module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( typeRepresentation(type) ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( data ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( (extension || '') ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( usage ))==null?'':__t)+
'</td>\r\n';
 if (!simpleView) { 
__p+='\r\n<td><input type="checkbox" id="preferred" value="preferred" ';
 if (preferred) { 
__p+=' checked ';
 } 
__p+='\r\n    ';
 if (!canEdit) { 
__p+=' disabled ';
 } 
__p+=' ></td>\r\n<td>'+
((__t=( priority ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( dateFrom ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( dateTo ))==null?'':__t)+
'</td>\r\n';
 } 
__p+='\r\n';
 if (simpleView) { 
__p+='\r\n<td>'+
((__t=( comment ))==null?'':__t)+
'</td>\r\n';
 } 
__p+='\r\n\r\n<td><a href="/#history/'+
((__t=( clearedReceiver() ))==null?'':__t)+
'" target="_blank"><span class="glyphicon glyphicon-time clickable"/></a></td>\r\n';
 if (canEdit) { 
__p+='\r\n<td><span class="glyphicon glyphicon-edit clickable" id="contact-edit" rel-id="'+
((__t=( data ))==null?'':__t)+
'"/></td>\r\n<td><span class="glyphicon glyphicon-remove clickable" id="contact-delete" rel-id="'+
((__t=( data ))==null?'':__t)+
'"/></td>\r\n';
 } 
__p+='\r\n<td>'+
((__t=( source || 'MANUAL' ))==null?'':__t)+
'</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/contacts/contacts-row.html
// module id = 251
// module chunks = 0